import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StoreProvider } from '@/stores/StoreContext';
import { OpenAPI } from '@pro-sto/api-client';
import { authStore } from '@/stores/AuthStore';
import { setupApiInterceptors } from '@/utils/setupApiInterceptors';
import { initializeFirebase } from '@/services/firebase';
import App from './App';

// Import global styles
import '@pro-sto/ui/styles/variables.css';
import '@pro-sto/ui/styles/reset.css';
import '@pro-sto/ui/styles/global.css';
import '@/styles/animations.css';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
  });
}

// В dev с прокси — относительные URL (/api/...), иначе CORS при полном VITE_API_BASE_URL
OpenAPI.BASE =
  import.meta.env.DEV && import.meta.env.VITE_API_PROXY_TARGET
    ? ''
    : (import.meta.env.VITE_API_BASE_URL ?? '');

// Настройка interceptors для автоматического обновления токенов
setupApiInterceptors(authStore);

// Инициализация Firebase при старте приложения
initializeFirebase();

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

createRoot(root, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <StoreProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StoreProvider>
  </StrictMode>,
);
